import { render, staticRenderFns } from "./account.vue?vue&type=template&id=7a7d969c&scoped=true"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7d969c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a7d969c')) {
      api.createRecord('7a7d969c', component.options)
    } else {
      api.reload('7a7d969c', component.options)
    }
    module.hot.accept("./account.vue?vue&type=template&id=7a7d969c&scoped=true", function () {
      api.rerender('7a7d969c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/customer/account.vue"
export default component.exports